"use client";

import React from "react";
import { LIST_FILTER_FIELD_SELECT } from "@/components/workspace/list-filter-toolbar";
import { SearchableSelect, type SearchableSelectProps } from "@/components/workspace/SearchableSelect";
import { cn } from "@/lib/utils";

export type ListToolbarSelectProps = Omit<SearchableSelectProps, "layout">;

function hasToolbarAllOption(options: ListToolbarSelectProps["options"], placeholder: string): boolean {
  const placeholderNorm = placeholder.trim().toLowerCase();
  return options.some((option) => {
    const optionValue = String(option.value ?? "").trim().toLowerCase();
    const optionLabel = option.label.trim().toLowerCase();
    if (optionValue === "" || optionValue === "all" || optionValue === "*") return true;
    return placeholderNorm.length > 0 && optionLabel === placeholderNorm;
  });
}

/** Sole list-toolbar filter select — applies LIST_FILTER_FIELD_SELECT + deduped clear row. */
export function ListToolbarSelect({
  className,
  allowClear,
  showRawValue = false,
  options,
  placeholder,
  ...rest
}: ListToolbarSelectProps) {
  return (
    <SearchableSelect
      {...rest}
      options={options}
      placeholder={placeholder}
      layout="toolbar"
      showRawValue={showRawValue}
      allowClear={allowClear ?? !hasToolbarAllOption(options, placeholder)}
      className={cn(LIST_FILTER_FIELD_SELECT, className)}
    />
  );
}

export default ListToolbarSelect;
